/*
 Licensed Materials - Property of IBM
 5737-I23
 Copyright IBM Corp. 2020. All Rights Reserved.
 U.S. Government Users Restricted Rights:
 Use, duplication or disclosure restricted by GSA ADP Schedule
 Contract with IBM Corp.
 */
import React from 'react';
import { FormLabel } from 'carbon-components-react';
import SchemaField from 'react-jsonschema-form/lib/components/fields/SchemaField';
import { getSchemaType } from 'react-jsonschema-form/lib/utils';

import './CustomSchemaField.scss';

function CustomSchemaField(props) {
    const { idSchema, required, registry } = props;
    let { schema } = props;
    const { fields, formContext } = registry;
    let unsupportedField, invalidRef = false;

    const COMPONENT_TYPES = {
        array: 'ArrayField',
        boolean: 'BooleanField',
        integer: 'NumberField',
        number: 'NumberField',
        object: 'ObjectField',
        string: 'StringField',
        null: 'NullField',
    };

    // when the schema contains a ref :
    if (schema.$ref) {
        try  {
            const definitionName = schema.$ref.split('/')[2];
            if (!registry.definitions[definitionName]) {
                invalidRef = true;
            } else {
                schema = registry.definitions[definitionName];
                if (props.schema.title) {
                    schema.title = props.schema.title;
                }
            }
        } catch {
            invalidRef = true;
        }
    }

    // unsupported field should be tested when the ref is valid and when schema is not empty
    if (!invalidRef && Object.getOwnPropertyNames(schema).length > 0) {
        const componentName = COMPONENT_TYPES[getSchemaType(schema)];
        if (!(componentName in fields)) {
            unsupportedField = true;
        }
    }

    if (unsupportedField) {
        const label = schema.title || idSchema.$id;
        return (
            <div className="bx--fieldset">
                <FormLabel >{label}{!required && formContext && formContext.optionalLabel ? ` (${formContext.optionalLabel})` : null}</FormLabel>
                <p className="baiw--unsupported-field">
                    {formContext ? formContext.unsupportedFieldLabel : ''}
                </p>
            </div>
        );
    }

    return (
        <SchemaField {...props} />
    );
}

export { CustomSchemaField };